import ColorSymbols from './ColorSymbols';

export default ColorSymbols;
